/**
 * @author PengWen
 * @description 新能源组织迁移  业务数据的受众/管理范围调整
 * @Date 2023/03/20
 */
import {component_tool,utils_tool} from "../../../tool";
import { WizTableForm } from '../../common'
let {WizModal} = component_tool
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const positionCategoryConfig = WizTableForm.Config.positionCategory()

let componentName = "bizDataMoveBiz"

const templateConfig = (self) => {
  const columns = [
        {
          name: "bizId",
          fromItem: {
            type: "hidden"
          }
        },
        {
          title: "业务数据名称",
          name: "bizName",
          searchItem: {},
          tableItem: {
            width: 300
          },
        },
        {
          title: "业务数据状态",
          name: "stateString",
          tableItem: {
            width: 170
          },
        },
        {
          title: "开始时间",
          name: "startTime",
          tableItem: {
            width: 170
          },
        },
        {
          title: "结束时间",
          name: "endTime",
          tableItem: {
            width: 170
          },
        },
        {
            title: "组织",
            name: "orgIds",
            searchItem: {
              diy: WizTableForm,
              ...organizationConfig
            }
        },
        {
            title: "岗位",
            name: "positionIds",
            searchItem: {
              diy: WizTableForm,
              ...positionConfig,
            }
        },
        {
            title: "岗位分类",
            name: "positionCategoryIds",
            searchItem: {
              diy: WizTableForm,
              ...positionCategoryConfig,
            }
        },
        {
            title: "人员",
            name: 'personIds',
            searchItem: {
              ...WizTableForm.Config.user(self, {apiParams: { state: 1 }}),
              diy: WizTableForm
            },
        },
        {
            title: "权限类型",
            name: "permType",
            searchItem: {
                type: "select",
            },
            dict: [
                {code:1,codeName:'受众范围'},
                {code:0,codeName:'管理范围'},
            ]
        },

  ];

  return {
    mainProps: {},
    content: {
        name: 'WizTableList',
        params: {
            columns,
            searchBarProps: {
                collapse: false,
                cols: {
                  xs: 24,
                  md: 12,
                  xl: 8
                },
                dataFormat: (params) => {
                  let value = Object.assign({}, params)
                  self.setState(value)
                  return value;
                },
                buttonSort: ['batchSet'],
                buttons: [
                  {
                    key: 'batchSet',
                    name: 'WizButton',
                    params: {
                      children: '批量替换受众范围',
                    },
                    onClick :(e) =>{
                      if (e && e.rows && e.rows.length) {
                        let record = e.rows;
                        console.log('record',record);
                        self.jumpPage('push', '/bizDataMove/bizDataMoveReplaceStudent', record)
                      } else {
                        WizModal.confirm({
                          title: '至少选择一条数据',
                          onOk: () => {},
                          onCancel() {}
                        })
                      }
                    }
                  },
                  {
                    key: 'batchSet',
                    name: 'WizButton',
                    params: {
                      children: '批量替换管理范围',
                    },
                    onClick :(e) =>{
                      if (e && e.rows && e.rows.length) {
                        let record = e.rows;
                        console.log('record',record);
                        self.jumpPage('push', '/bizDataMove/bizDataMoveReplaceManager', record)
                      } else {
                        WizModal.confirm({
                          title: '至少选择一条数据',
                          onOk: () => {},
                          onCancel() {}
                        })
                      }
                    }
                  },
                  {
                    key: 'batchSet',
                    name: 'WizButton',
                    params: {
                      children: '批量新增受众范围',
                    },
                    onClick :(e) =>{
                      if (e && e.rows && e.rows.length) {
                        let record = e.rows;
                        console.log('record',record);
                        self.jumpPage('push', '/bizDataMove/bizDataMoveAddStudent', record)
                      } else {
                        WizModal.confirm({
                          title: '至少选择一条数据',
                          onOk: () => {},
                          onCancel() {}
                        })
                      }
                    }
                  },
                  {
                    key: 'batchSet',
                    name: 'WizButton',
                    params: {
                      children: '批量新增管理范围',
                    },
                    onClick :(e) =>{
                      if (e && e.rows && e.rows.length) {
                        let record = e.rows;
                        console.log('record',record);
                        self.jumpPage('push', '/bizDataMove/bizDataMoveAddManager', record)
                      } else {
                        WizModal.confirm({
                          title: '至少选择一条数据',
                          onOk: () => {},
                          onCancel() {}
                        })
                      }
                    }
                  },
                  {
                    key: 'batchSet',
                    name: 'WizButton',
                    params: {
                      children: '批量删除受众范围',
                    },
                    onClick :(e) =>{
                      if (e && e.rows && e.rows.length) {
                        let record = e.rows;
                        console.log('record',record);
                        self.jumpPage('push', '/bizDataMove/bizDataMoveDeleteStudent', record)
                      } else {
                        WizModal.confirm({
                          title: '至少选择一条数据',
                          onOk: () => {},
                          onCancel() {}
                        })
                      }
                    }
                  },
                  {
                    key: 'batchSet',
                    name: 'WizButton',
                    params: {
                      children: '批量删除管理范围',
                    },
                    onClick :(e) =>{
                      if (e && e.rows && e.rows.length) {
                        let record = e.rows;
                        console.log('record',record);
                        self.jumpPage('push', '/bizDataMove/bizDataMoveDeleteManager', record)
                      } else {
                        WizModal.confirm({
                          title: '至少选择一条数据',
                          onOk: () => {},
                          onCancel() {}
                        })
                      }
                    }
                  },
                ]
              },
            modalFormProps: {},
            dataTableProps: {
                rowKey: 'bizId',
                selectType: 'checkbox',
                isScroll: true,
                bordered: false,
                paging: false,
                loading: false
            },
            rowOperateSort: [],
            rowOperateView: [],
            rowOperateProps: {
                width: 300,
                fixed: 'right',
            },
            showAuth: [
                {
                  title: "受众范围",
                  text: '查看',
                  dataIndex: "authInfo",
                  width: 150
                },
                {
                  title: "管理范围",
                  text: '查看',
                  dataIndex: "managerAuthInfo",
                  width: 150
                },
            ],
        }
    }
  };

  
}


let reduxTemplateConfig = (args) => {
    const { record } = args;
    const { id } = record; 
    const apis = {
        list: {
          path: `${componentName}/bizDataBizPageList`,
          payload: {
            key: `${componentName}@bizDataBizPageList`,
            apiParams: {businessId : id}
          }
        },
    }

    return {
      apis,
      componentName,
      initApiKeys: ['list'],
      needLoading: true,
      keepInitApiParams: true,
      ...args
    }
};
  
export {reduxTemplateConfig, templateConfig};